/* @flow */
import * as React from 'react';

const ChevronUp = ({ color, ...props }: { color: ?string }) => (
  <svg width={20} height={12} viewBox="0 0 20 12" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill={color || '#FFFFFF'}
      fillRule="evenodd"
      d="M18.5,11.5 L20,10 L10,0 L0,10 L1.5,11.5 L10,3 L18.5,11.5 Z"
    />
  </svg>
);

export default ChevronUp;



// WEBPACK FOOTER //
// ./src/assets/images/icons/chevron-up.js